import Vue from 'vue'

Vue.component('cmp-mdp-fin-model-form', require('./model/cmp-mdp-fin-model-form').default)
Vue.component('cmp-mdp-fin-size-detail', require('./model/cmp-mdp-fin-size-detail').default)
